import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPlanAPI,
  getAllPlansAPI,
  getPlanByIdAPI,
  updatePlanAPI,
  deletePlanAPI,
} from "../../../Service/plan.services";

export const CREATE_PLAN = createAsyncThunk(
  "admin/createPlan",
  async ({ data, token }) => {
    try {
      const response = await createPlanAPI(data, token);
      return response;
    } catch (error) {
      return {
        success: false,
        msg: error.message || "Network Error",
      };
    }
  }
);


export const GET_ALL_PLANS = createAsyncThunk(
  "admin/getAllPlans",
  async ({ token, filters = {} }) => {
    try {
      const response = await getAllPlansAPI(token, filters);
      return response;
    } catch (error) {
      return {
        success: false,
        msg: error.message || "Network Error",
      };
    }
  }
);


export const GET_PLAN_BY_ID = createAsyncThunk(
  "admin/getPlanById",
  async ({ id, token }) => {
    try {
      const response = await getPlanByIdAPI(id, token);
      return response;
    } catch (error) {
      return {
        success: false,
        msg: error.message || "Network Error",
      };
    }
  }
);

export const UPDATE_PLAN = createAsyncThunk(
  "admin/updatePlan",
  async ({ id, data, token }) => {
    try {
      const response = await updatePlanAPI(id, data, token);
      return response;
    } catch (error) {
      return {
        success: false,
        msg: error.message || "Network Error",
      };
    }
  }
);

// DELETE Plan
export const DELETE_PLAN = createAsyncThunk(
  "admin/deletePlan",
  async ({ id, token }) => {
    try {
      const response = await deletePlanAPI(id, token);
      return response;
    } catch (error) {
      return {
        success: false,
        msg: error.message || "Network Error",
      };
    }
  }
);

const AdminPlanSlice = createSlice({
  name: "adminPlan",
  initialState: {
    plans: [],
    selectedPlan: null,
    loading: false,
    error: null,
    isLoading: false,
    isError: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedPlan: (state) => {
      state.selectedPlan = null;
    },
  },
  extraReducers: {
    // CREATE Plan
    [CREATE_PLAN.pending]: (state) => {
      return { ...state, loading: true, isLoading: true, error: null };
    },
    [CREATE_PLAN.fulfilled]: (state, { payload }) => {
      if (payload.success && payload.data) {
        return {
          ...state,
          plans: [payload.data, ...state.plans],
          loading: false,
          isLoading: false,
        };
      }
      return { ...state, loading: false, isLoading: false };
    },
    [CREATE_PLAN.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        isLoading: false,
        error: action.payload?.msg || "Failed to create plan",
      };
    },

    // GET All Plans
    [GET_ALL_PLANS.pending]: (state) => {
      return { ...state, loading: true, isLoading: true, error: null };
    },
    [GET_ALL_PLANS.fulfilled]: (state, { payload }) => {

      let plansData = [];
      
      if (payload?.success && payload?.data && Array.isArray(payload.data)) {
        plansData = payload.data;
      } else if (Array.isArray(payload)) {
        plansData = payload;
      }
      
      return {
        ...state,
        plans: plansData,
        loading: false,
        isLoading: false,
        error: null,
      };
    },
    [GET_ALL_PLANS.rejected]: (state, action) => {
      console.error("GET_ALL_PLANS rejected:", action);
      return {
        ...state,
        loading: false,
        isLoading: false,
        error: action.payload?.msg || "Failed to fetch plans",
        plans: [],
      };
    },

    // GET Plan by ID
    [GET_PLAN_BY_ID.pending]: (state) => {
      return { ...state, loading: true, isLoading: true, error: null };
    },
    [GET_PLAN_BY_ID.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        selectedPlan: payload?.data || null,
        loading: false,
        isLoading: false,
      };
    },
    [GET_PLAN_BY_ID.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        isLoading: false,
        error: action.payload?.msg || "Failed to fetch plan",
      };
    },

    // UPDATE Plan
    [UPDATE_PLAN.pending]: (state) => {
      return { ...state, loading: true, isLoading: true, error: null };
    },
    [UPDATE_PLAN.fulfilled]: (state, { payload }) => {
      if (payload.success && payload.data) {
        const updatedPlans = state.plans.map((plan) =>
          plan._id === payload.data._id ? payload.data : plan
        );
        return {
          ...state,
          plans: updatedPlans,
          loading: false,
          isLoading: false,
        };
      }
      return { ...state, loading: false, isLoading: false };
    },
    [UPDATE_PLAN.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        isLoading: false,
        error: action.payload?.msg || "Failed to update plan",
      };
    },

    // DELETE Plan
    [DELETE_PLAN.pending]: (state) => {
      return { ...state, loading: true, isLoading: true, error: null };
    },
    [DELETE_PLAN.fulfilled]: (state, { payload }) => {
      if (payload.success && payload.data) {
        const filteredPlans = state.plans.filter(
          (plan) => plan._id !== payload.data._id
        );
        return {
          ...state,
          plans: filteredPlans,
          loading: false,
          isLoading: false,
        };
      }
      return { ...state, loading: false, isLoading: false };
    },
    [DELETE_PLAN.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        isLoading: false,
        error: action.payload?.msg || "Failed to delete plan",
      };
    },
  },
});

export const { clearError, clearSelectedPlan } = AdminPlanSlice.actions;

// Selector
export const getPlanData = (state) => state && state.adminPlan;

export default AdminPlanSlice;